import { createAction } from 'typesafe-actions';
import { RequestState } from '../../constants/request-state';
import { LoanFieldValues } from '../../types/loan/LoanFieldValues';

const request = createAction(
    'entities/loanFieldValues/REQUEST',
    resolve => (requestState: RequestState) => resolve({ requestState }),
);

const response = createAction(
    'entities/loanFieldValues/RESPONSE',
    resolve => (requestState: RequestState, values: LoanFieldValues) => resolve({ requestState, values }),
);

const reset = createAction('entities/loanFieldValues/RESET');

export const loanFieldValuesActions = { request, response, reset };
